import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/dossiers',
  validateSearch: (search: Record<string, unknown>): { queue?: string } => ({
    queue: typeof search.queue === 'string' && search.queue.length > 0 ? search.queue : undefined,
  }),
}).lazy(() => import('./dossiers.lazy').then((d) => d.Route))
